import { createReducer, on } from '@ngrx/store';
import { GetDynamicPermissionsByQueryCommand } from './dynamic-permission.commands';
import {
  CreatedDynamicPermissionDomainEvent,
  GottenDynamicPermissionsByQueryDomainEvent,
  GottenDynamicPermissionsDomainEvent,
  UpdatedDynamicPermissionDomainEvent,
} from './dynamic-permission.events';
import { DynamicPermissionState, initialAuthState } from './dynamic-permission.state';

export const dynamicPermissionKey = 'dynamicPermission';

export const DynamicPermissionReducer = createReducer<DynamicPermissionState, any>(
  initialAuthState,

  on(GottenDynamicPermissionsDomainEvent, (state, { dynamicPermissions }) => {
    const newDynamicPermissions = { ...state.dynamicPermissions };
    for (const resource of dynamicPermissions) {
      newDynamicPermissions[resource.id] = resource;
    }
    return {
      ...state,
      dynamicPermissions: newDynamicPermissions,
    };
  }),

  on(GetDynamicPermissionsByQueryCommand, (state, {}) => {
    return {
      ...state,
      dynamicPermissionsByQuery: undefined,
    };
  }),

  on(GottenDynamicPermissionsByQueryDomainEvent, (state, { dynamicPermissions }) => {
    const newDynamicPermission = { ...state.dynamicPermissions };
    for (const resource of dynamicPermissions) {
      newDynamicPermission[resource.id] = resource;
    }

    return {
      ...state,
      dynamicPermissions: newDynamicPermission,
      dynamicPermissionsByQuery: dynamicPermissions.map((x) => x.id),
    };
  }),

  on(CreatedDynamicPermissionDomainEvent, (state, { dynamicPermission }) => {
    const newDynamicPermission = { ...state.dynamicPermissions };

    newDynamicPermission[dynamicPermission.id] = dynamicPermission;
    return {
      ...state,
      dynamicPermissions: newDynamicPermission,
    };
  }),
  on(UpdatedDynamicPermissionDomainEvent, (state, { dynamicPermission }) => {
    const newDynamicPermission = { ...state.dynamicPermissions };

    newDynamicPermission[dynamicPermission.id] = dynamicPermission;
    return {
      ...state,
      dynamicPermissions: newDynamicPermission,
    };
  }),
);
